import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SubmissionDetails from '../../../SubmissionDetails';
import GruserZoneLocal from '../../GruserZone/Local';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { DetailsProps } from '../types';
import ExtendedDetails from './ExtendedDetails';

import s from './Default.scss';

export const DefaultDetails: React.FC<DetailsProps> = ({
  deviation,
  className,
  contentClassName,
}) => {
  const isMobile = useContext(MobileContext);
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);

  return (
    <div className={classnames(s['root'], className, contentClassName)}>
      <div className={s['title-block']}>
        <SubmissionDetails deviation={deviation} showTitle />
      </div>
      {isExtendedLoaded && <ExtendedDetails deviation={deviation} />}
      {!isMobile && <GruserZoneLocal deviation={deviation} />}
    </div>
  );
};
DefaultDetails.displayName = 'DefaultDetails';

export default DefaultDetails;
